module.exports = __webpack_public_path__ + "img/tooltip-icon.21abc122.svg";